module.exports = __webpack_public_path__ + "img/caniuse-resume.80d3087e.png";